var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/context/provider/rum-provider.tsx
import React from "react";
var noop = () => void 0;
var RumContext = React.createContext({
  manager: {
    trackEvent: noop
  }
});
var RumProvider = ({
  children,
  manager
}) => {
  const value = React.useMemo(() => ({
    manager
  }), [manager]);
  return /* @__PURE__ */React.createElement(RumContext.Provider, {
    value
  }, children);
};
RumProvider.displayName = "RumProvider";

// src/context/hooks/use-component-rum-tracker.tsx
import { useCallback, useContext, useMemo } from "react";
var useComponentRumTracker = ({
  componentId,
  componentName
}) => {
  const {
    manager
  } = useContext(RumContext);
  const memoizedTrackEvent = useCallback((type, params) => {
    const event = __spreadProps(__spreadValues({}, params), {
      type,
      // TODO(alvaleri): viewId should be retrieved from the context once implemented.
      viewId: void 0,
      timestamp: performance.now(),
      componentId,
      componentName
    });
    manager.trackEvent(event);
  }, [manager, componentId, componentName]);
  return useMemo(() => ({
    trackEvent: memoizedTrackEvent
  }), [memoizedTrackEvent]);
};

// src/context/hooks/use-interaction-rum-tracker.tsx
import { useCallback as useCallback2, useContext as useContext2, useMemo as useMemo2 } from "react";
var useInteractionRumTracker = () => {
  const {
    manager
  } = useContext2(RumContext);
  const memoizedTrackEvent = useCallback2((type, params) => {
    const event = __spreadProps(__spreadValues({}, params), {
      type,
      // TODO(alvaleri): viewId should be retrieved from the context once implemented.
      viewId: void 0,
      timestamp: performance.now()
    });
    manager.trackEvent(event);
  }, [manager]);
  return useMemo2(() => ({
    trackEvent: memoizedTrackEvent
  }), [memoizedTrackEvent]);
};
export { RumProvider, useComponentRumTracker, useInteractionRumTracker };
//# sourceMappingURL=index.js.map